
import {throwError as observableThrowError, Observable, of} from 'rxjs';

import {map, catchError, switchMap} from 'rxjs/operators';
import {Injectable, Injector} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor, HttpErrorResponse, HttpEvent, HttpResponse
} from '@angular/common/http';
import {AuthService} from '../../../services/api/auth/auth.service';
import {TokenService} from '../../../services/local/token/token.service';
import {Router} from '@angular/router';
import {LocalStorageService} from 'ngx-webstorage';
import * as moment from 'moment';
import {LinaConstants} from '../../../shared/constants/constants';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(private injector: Injector,
              private storage: LocalStorageService,
              private authService: AuthService,
              private tokenService: TokenService,
              private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        // Save last activity time stamp
        if (event instanceof HttpResponse && (event.status === 200)) {
          this.storage.store('lastActivity', moment());
        }
        return event;
      }),
      catchError((error) => {
        // Check for errors that should trigger refresh token
        if (error instanceof HttpErrorResponse) {
            if (error.status === 401) {
              if (request.url.indexOf('Account/RefreshToken') === -1 && request.url.indexOf('Account/Login') === -1) {

                const keepMeLoggedIn = this.tokenService.getKeepMeLoggedIn();
                const lastActivity = this.storage.retrieve('lastActivity');
                if (!keepMeLoggedIn &&
                  lastActivity &&
                  moment().diff(moment(lastActivity), 'minutes') > LinaConstants.inactivityLimit) {
                  return this.errorHandler(error);
                } else {

                  const refreshToken = this.tokenService.getRefreshToken();
                  if (refreshToken) {

                    return this.authService.reLogin({Token: refreshToken, Client: 'LinaApp'}).pipe(switchMap(_ => {
                      return next.handle(request);
                    }),
                    catchError((refreshError) => {
                      return this.errorHandler(refreshError);
                    }));

                  } else {
                    return this.errorHandler(error);
                  }
                }
              } else {
                return this.errorHandler(error);
              }

            } else if (error.status === 404) {
              // Not found
              return observableThrowError(error);
            } else {
              return observableThrowError(error);
            }
          } else {
            return observableThrowError(error);
          }
      })) as Observable<HttpEvent<any>>;
  }

  errorHandler(error) {
    this.authService.logout();
    this.router.navigateByUrl('/auth/login');
    return observableThrowError(of(error));
  }
}
